import { Container as ProcessesContainer } from './Container';
export default ProcessesContainer;
